module.exports = __webpack_public_path__ + "static/media/regenland-white.c20005be.png";